import { render, staticRenderFns } from "./ActionsDownload.vue?vue&type=template&id=3b1c83c7"
import script from "./ActionsDownload.vue?vue&type=script&lang=js"
export * from "./ActionsDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports